<div class="splash">
    <div class="icon">
        <i class="zmdi zmdi-spinner zmdi-hc-3x zmdi-hc-spin"></i>
    </div>
</div>